// Import router
import Router from './router';

// Import local deps
import common from './routes/common';

//singles
import single_enquiry from './routes/single-enquiry';
import single_operator from './routes/single-operator';

import approve_quote from './routes/approve-quote';

import dashboard from './routes/dashboard';
import add_customer from './routes/add-customer';
import edit_customer from './routes/edit-customer';

import edit_operator_user from './routes/edit-operator-user';
import add_operator_user from './routes/edit-operator-user';

import register_new_contact from './routes/add-contact';
import register_new_agent from './routes/add-contact';
import register_new_operator from './routes/add-contact';
import edit_contact from './routes/edit-contact';

import contact from './routes/contact';

import operators_products from './routes/operators-products';
import operators from './routes/operators';
import accommodation from './routes/accommodation';

import duplicate_enquiry from './routes/duplicate-enquiry';

import add_enquiry from './routes/add-enquiry';
import edit_enquiry from './routes/edit-enquiry';

import add_note from './routes/add-note';
import edit_note from './routes/edit-note';

import test from './routes/import-xml';

import agent_commission_reporting from './routes/reporting.js';
import child_agent_reporting from './routes/reporting.js';
import reporting_overall from './routes/reporting.js';

import single_product from '../../brochure-theme-shared/assets/scripts/routes/product'
import preview_product from '../../brochure-theme-shared/assets/scripts/routes/product'
import single_accommodation from '../../brochure-theme-shared/assets/scripts/routes/accommodation'
import preview_accommodation from '../../brochure-theme-shared/assets/scripts/routes/accommodation'

// Import ajaxForm
import './ajax-form';

// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.
// You add additional pages to this array by referencing the the body class
// and creating the js file in the routes directory. Remember to import the
// file as per the common example near the top of this file.
const routes = {
  // All pages
  common,
  single_enquiry,
  single_product,
  single_accommodation,
  single_operator,
  approve_quote,
  dashboard,
  add_customer,
  edit_customer,
  register_new_contact,
  register_new_agent,
  register_new_operator,
  edit_contact,
  contact,
  operators_products,
  operators,
  accommodation,
  duplicate_enquiry,
  add_enquiry,
  edit_enquiry,
  add_note,
  edit_note,
  preview_product,
  preview_accommodation,
  test,
  agent_commission_reporting,
  child_agent_reporting,
  reporting_overall,
  edit_operator_user,
  add_operator_user
};

// Load Events
document.addEventListener('DOMContentLoaded', () => new Router(routes).loadEvents());

// Window Loaded
window.onload = () => new Router(routes).loadEvents('loaded');
